import React, { useState } from "react";
import Icons from "../../../../../Config/Images";
import "./Section1.css";
import { useNavigate } from "react-router-dom";
import Header from "../../Common/Header";

const Section1 = ({ onManufactureClick, onRetailerClick }) => {
  return (
    <>
      <div className="section-1">
        <div className="section-1-content">
          <div className="left-side-content">
            <p className="h4-para" style={{ marginBottom: "20px" }}>
              Unlock Exclusive Access to Directly Sourced Jewelry
            </p>
            <p className="h2-para" style={{ marginBottom: "20px" }}>
              Zabali, Your Digital Trusted Salesman
            </p>
            <p className="content-para">
              {/* Zabali is your premier platform designed for retailers seeking
              high-quality jewelry at competitive prices. By partnering with us,
              you gain direct access to a curated selection of unique pieces
              crafted by skilled artisans. Streamline your purchasing process
              and elevate your inventory with exclusive deals tailored just for
              you. */}
              Zabali is the ultimate platform for retailers seeking high-quality
              jewelry at unbeatable prices. We provide access to exclusive
              collections sourced at manufacturing rates, ensuring your
              inventory stands out in a competitive market. Join us and take
              your retail business to new heights.
            </p>
            {/* <div className="section-1-content-btns">
              <div className="btn-div retailer-btn" onClick={onRetailerClick}>
                Become Retailer
              </div>
              <div
                className="btn-div manufacturer-btn"
                onClick={onManufactureClick}
              >
                Become a Manufacturer
              </div>
            </div> */}
          </div>
          <div className="right-side-content">
            <img
              className="zabali-logo"
              src={Icons.welcome_zabali_logo}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Section1;
